import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import AppShell from "./components/AppShell";
import { AuthenticationGuard } from "./components/authentication-guard";
import { CallbackPage } from "./pages/callback-page";
import { NotFoundPage } from "./pages/not-found-page";
import Dashboard from "pages/dashboard/Dashboard";
import Clients from "pages/clients/Clients";
import Patients from "pages/patients/Patients";
import Calendar from "pages/calendar/Calendar";
import Services from "pages/services/Services";
import Staff from "pages/staff/Staff";
import Clinics from "pages/clinics/Clinics";
import Profile from "pages/profile/Profile";

import ClientsList from "pages/clients/ClientsList";
import NewCustomer from "pages/clients/NewCustomer";
import CustomerDetails from "pages/clients/CustomerDetails";

import PatientsList from "pages/patients/PatientsList";
import NewPatient from "pages/patients/NewPatient";
import PatientDetails from "pages/patients/PatientDetails";
import InvoiceDetails from "pages/invoices/InvoiceDetails";

import ServicesList from "pages/services/ServicesList";
import NewService from "pages/services/NewService";
import ServiceDetails from "pages/services/ServiceDetails";

import StaffList from "pages/staff/StaffList";
import NewStaff from "pages/staff/NewStaff";
import StaffDetails from "pages/staff/StaffDetails";

import ClinicsList from "pages/clinics/ClinicsList";
import NewClinic from "pages/clinics/NewClinic";
import ClinicDetails from "pages/clinics/ClinicDetails";
import ProviderPublicPage from "pages/public/ProviderPublicPage";
import Facilities from "pages/facilities/Facilities";
import GravePlots from "pages/cemetery/GravePlots";
import ArrangementsList from "pages/arrangements/ArrangementsList";
import ArrangementDetails from "pages/arrangements/ArrangementDetails";
import ProviderRequests from "pages/requests/ProviderRequests";
import MarketplacePage from "pages/public/MarketplacePage";
import RequestStatusPage from "pages/public/RequestStatusPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route
        path="/app"
        element={<AuthenticationGuard component={AppShell} />}
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />

        <Route path="clients" element={<Clients />}>
          <Route index element={<ClientsList />} />
          <Route path="new-customer" element={<NewCustomer />} />
          <Route path=":orgId/:id" element={<CustomerDetails />} />
          <Route path=":id" element={<CustomerDetails />} />
        </Route>

        {/* Static `new` must be registered before `:id` or `new` is treated as a detail id. */}
        <Route path="patients" element={<Patients />}>
          <Route index element={<PatientsList />} />
          <Route path="new/:contactId" element={<NewPatient />} />
          <Route path="new" element={<NewPatient />} />
          <Route
            path="new-patient"
            element={<Navigate to="/app/patients/new" replace />}
          />
          <Route path=":id" element={<PatientDetails />} />
        </Route>

        <Route path="invoices/:id" element={<InvoiceDetails />} />
        <Route path="facilities" element={<Facilities />} />
        <Route path="grave-plots" element={<GravePlots />} />
        <Route path="arrangements" element={<ArrangementsList />} />
        <Route path="arrangements/:id" element={<ArrangementDetails />} />
        <Route path="requests" element={<ProviderRequests />} />
        <Route path="calendar" element={<Calendar />} />

        <Route path="services" element={<Services />}>
          <Route index element={<ServicesList />} />
          <Route path="new-service" element={<NewService />} />
          <Route path=":id" element={<ServiceDetails />} />
        </Route>

        <Route path="staff" element={<Staff />}>
          <Route index element={<StaffList />} />
          <Route path="new-staff" element={<NewStaff />} />
          <Route path=":id" element={<StaffDetails />} />
        </Route>

        <Route path="clinics" element={<Clinics />}>
          <Route index element={<ClinicsList />} />
          <Route path="new-clinic" element={<NewClinic />} />
          <Route path=":id" element={<ClinicDetails />} />
        </Route>

        <Route path="profile" element={<Profile />} />
      </Route>

      {/* Public: anyone can see a listed provider, signed in or not. */}
      <Route path="/providers/:orgId" element={<ProviderPublicPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/marketplace/requests/:reference" element={<RequestStatusPage />} />

      <Route path="/loginCallback" element={<CallbackPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
